module.exports = __webpack_public_path__ + "static/img/logo_mini.9baa4642.png";